import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//import { SearchResultsComponent } from './search-results/search-results.component';

import { AuthGuard } from 'src/app/auth/auth.guard';
import { AdminCommunicationsComponent } from './admin-communications/admin-communications.component';
import { AdminValidationsComponent } from './admin-validations/admin-validations.component';
import { AdminTransactionsComponent } from './admin-transactions/admin-transactions.component';

import { AdminComponent } from './admin.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminCarsComponent } from './admin-cars/admin-cars.component';
import { AdminContractsComponent } from './admin-contracts/admin-contracts.component';

import { AdminCarRefsComponent } from './admin-carrefs/admin-carrefs.component';
import { AdminBuyComponent } from './admin-buy/admin-buy.component';
import { AdminRentComponent } from './admin-rent/admin-rent.component';
import { AdminKeepComponent } from './admin-keep/admin-keep.component';
import { DealerAccountComponent } from '../dealer/dealer-account/dealer-account.component';
import { DealerConversationsComponent } from '../dealer/dealer-conversations/dealer-conversations.component';
import { DealerNotificationsComponent } from '../dealer/dealer-notifications/dealer-notifications.component';
import { DealerAppointmentsComponent } from '../dealer/dealer-appointments/dealer-appointments.component';
import { CarRefItemCode } from 'src/app/public/car/constants/car-basic-data';


const routes: Routes = [
  {
    path: '', component: AdminComponent,
    children: [
      { path: '', component: AdminDashboardComponent   },
      { path: 'dashboard', component: AdminDashboardComponent  },

      { path: 'users', component: AdminUsersComponent  },
      { path: 'contracts', component: AdminContractsComponent  },

      { path: 'carrefs', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.MAN }   },
      { path: 'carrefs/manufacturers', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.MAN } },
      { path: 'carrefs/makes', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.MAK } },
      { path: 'carrefs/models', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.MOD } },
      { path: 'carrefs/versions', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.VER } },
      { path: 'carrefs/engines', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.ENG } },
      { path: 'carrefs/features', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.FEA } },

      { path: 'carrefs/job-templates', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.JTE } },
      { path: 'carrefs/job-tasks', component: AdminCarRefsComponent, data: { selected: CarRefItemCode.JTA } },

      { path: 'cars', component: AdminCarsComponent  },

      { path: 'buy', component: AdminBuyComponent  },
      { path: 'rent', component: AdminRentComponent  },
      { path: 'keep', component: AdminKeepComponent  },

      { path: 'appointments', component: DealerAppointmentsComponent  },
      { path: 'conversations', component: DealerConversationsComponent  },
      { path: 'notifications', component: DealerNotificationsComponent  },

      { path: 'transactions', component: AdminTransactionsComponent  },
      { path: 'validations', component: AdminValidationsComponent  },
      { path: 'communications', component: AdminCommunicationsComponent  },

      { path: 'account', component: DealerAccountComponent  },
      
    
      //{ path: '', component: SearchComponent },
      //{ path: 'about', component: AboutComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/buy-car/search', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
